/* Front Line "my gun" layer — collection grids and model pages.
   Product cards carry data-fl-handle; when a gun is remembered, holster cards get "Fits your <gun>" or a muted
   "Not for your <gun>", and a bar above the grid says whose fit is shown. Gun model pages set the gun themselves.
   Data: assets/fitment-index.json (built by frontline-shopify/catalog-finder-index.mjs). */
(function () {
  if (!window.FLGun) return;
  var idxPromise = null;
  function index() {
    if (!idxPromise) idxPromise = fetch(FLGun.indexUrl, { credentials: 'omit' }).then(function (r) { return r.json(); }).catch(function () { return null; });
    return idxPromise;
  }
  function fitHandles(idx, g) {
    if (!idx || !g) return null;
    var b = idx.brands.find(function (x) { return x.n === g.b; }); if (!b) return null;
    var m = b.m.find(function (x) { return x.l === g.l; }); if (!m) return null;
    var out = {};
    m.t.forEach(function (ti) { idx.templates[ti].forEach(function (pi) { out[idx.products[pi].h] = true; }); });
    return out;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function decorate() {
    var cards = document.querySelectorAll('[data-fl-handle]');
    if (!cards.length) return;
    var g = FLGun.get();
    index().then(function (idx) {
      if (!idx) return;
      var known = {}; idx.products.forEach(function (p) { known[p.h] = true; });
      var main = document.querySelector('.collection__window');   /* the collection page's own product grid */
      var fits = fitHandles(idx, g);
      var shown = 0, fitting = 0, grid = null;
      cards.forEach(function (card) {
        var h = card.getAttribute('data-fl-handle'), badge = card.querySelector('[data-fl-fit]');
        card.classList.remove('fl-not-fit');
        if (badge) { badge.className = 'fl-fit'; badge.textContent = ''; }
        if (!fits || !known[h]) return;
        shown++; if (!grid && main && main.contains(card)) grid = card.parentElement;
        if (fits[h]) { fitting++; if (badge) { badge.className = 'fl-fit is-yes'; badge.textContent = 'Fits your ' + FLGun.label(g); } }
        else { card.classList.add('fl-not-fit'); if (badge) { badge.className = 'fl-fit is-no'; badge.textContent = 'Not made for your ' + FLGun.label(g); } }
      });
      var bar = document.querySelector('.fl-gridbar');
      if (!g) {   /* no pistol yet: invite to pick one right here (holster grids only) */
        var any = null; cards.forEach(function (c) { if (!any && main && main.contains(c) && known[c.getAttribute('data-fl-handle')]) any = c; });
        if (!any) { if (bar) bar.remove(); return; }
        if (!bar) { bar = document.createElement('div'); bar.className = 'fl-gridbar'; any.parentElement.parentElement.insertBefore(bar, any.parentElement); }
        if (!bar.querySelector('[data-flgs]')) {
          bar.innerHTML = '<span>Carry a specific pistol? <strong>Pick it and we\u2019ll mark the holsters that fit.</strong></span>' +
            '<div class="flgs" data-flgs data-mode="set" data-via="collection"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
            '<input type="search" autocomplete="off" placeholder="e.g. Glock 19" aria-label="Search your pistol"><ul role="listbox" hidden></ul></div>';
          if (window.FLGunSearch) FLGunSearch.scan(bar);
        }
        return;
      }
      if (!fits || !shown || !grid) { if (bar) bar.remove(); return; }
      if (!bar && grid) { bar = document.createElement('div'); bar.className = 'fl-gridbar'; grid.parentElement.insertBefore(bar, grid); }
      if (bar) {
        if (bar.querySelector('[data-flgs]')) bar.innerHTML = '';
        bar.innerHTML = '<span>Showing fit for your <strong>' + esc(FLGun.label(g)) + '</strong>: ' + fitting + ' of ' + shown + ' holsters here fit it.</span>' +
          '<a href="' + esc(FLGun.finderUrl(g)) + '">Find all holsters for it</a>' +
          '<button type="button" data-flmy-open>Change or clear</button>';
        var chg = bar.querySelector('[data-flmy-open]'); if (chg) chg.onclick = function () { openPanel(chg); };
      }
    });
  }
  function modelPage() {
    var el = document.querySelector('[data-fl-model-collection]'); if (!el) return;
    var handle = el.getAttribute('data-fl-model-collection');
    index().then(function (idx) {
      if (!idx || !idx.pages) return;
      var model = Object.keys(idx.pages).find(function (k) { return idx.pages[k] === handle; }); if (!model) return;
      var hits = [];
      idx.brands.forEach(function (b) { b.m.forEach(function (m) { if (m.h === model) hits.push({ b: b.n, l: m.l }); }); });
      if (hits.length === 1) FLGun.set(hits[0], 'model_page');
    });
  }
  // Once a pistol is remembered: the hero button and the finder slide of the announcement bar speak about it
  // (the homepage finder strip hides itself through html.fl-has-gun).
  function personalize() {
    var g = FLGun.get();
    var heroBtns = [].slice.call(document.querySelectorAll('.image-hero a[href^="/pages/holster-finder-quiz"]'));
    // re-queried on every fill: the announcement slider clones its slides after load
    function bar() {
      return [].slice.call(document.querySelectorAll('.announcement-bar a.announcement-bar__link[href^="/pages/holster-finder-quiz"]')).map(function (a) {
        if (!a.hasAttribute('data-fl-orig')) { a.setAttribute('data-fl-orig', a.innerHTML); a.setAttribute('data-fl-orig-href', a.getAttribute('href')); }
        return a;
      });
    }
    heroBtns.forEach(function (a) { if (!a.hasAttribute('data-fl-orig')) a.setAttribute('data-fl-orig', a.textContent.trim()); });
    if (!g) {
      heroBtns.forEach(function (a) { a.textContent = a.getAttribute('data-fl-orig'); a.setAttribute('href', '/pages/holster-finder-quiz'); });
      bar().forEach(function (a) { a.innerHTML = a.getAttribute('data-fl-orig'); a.setAttribute('href', a.getAttribute('data-fl-orig-href')); });
      return;
    }
    var short = FLGun.short(g), results = FLGun.finderUrl(g, 'carry=all');
    heroBtns.forEach(function (a) { a.textContent = 'Holsters for your ' + short; a.setAttribute('href', results); });
    function fill(n) {
      var name = '<span class="flbar-gun__n">' + esc(short.toUpperCase()) + '</span>';
      bar().forEach(function (a) {
        var mobile = !!a.closest('.announcement-bar__item-inner-mobile-only');
        a.innerHTML = '<p class="flbar-gun">' + (mobile ? '<span>YOUR&nbsp;</span>' + name + '<span>&nbsp;HOLSTERS&nbsp;\u2192</span>'
          : '<span>YOUR&nbsp;</span>' + name + '<span>:&nbsp;' + (n ? 'SEE THE ' + n + ' HOLSTERS MADE FOR IT' : 'SEE THE HOLSTERS MADE FOR IT') + '&nbsp;\u2192</span>') + '</p>';
        a.setAttribute('href', results);
      });
    }
    fill(0);
    index().then(function (idx) { var fits = fitHandles(idx, g), cur = FLGun.get(); if (fits && cur && cur.b === g.b && cur.l === g.l) fill(Object.keys(fits).length); });
  }
  // "My pistol" pill in the header (snippets/fl-my-pistol.liquid) and its panel: see, change or clear the pistol anywhere
  var panel = null, SEARCH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
  function closePanel() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    document.querySelectorAll('[data-flmy]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function fillPanel() {
    var g = FLGun.get(); if (!panel) return;
    if (!g) { closePanel(); return; }
    panel.querySelector('[data-flmy-gun]').textContent = FLGun.label(g);
    var go = panel.querySelector('[data-flmy-go]');
    go.href = FLGun.finderUrl(g, 'carry=all'); go.textContent = 'See the holsters made for it \u2192';
    index().then(function (idx) { var f = fitHandles(idx, g), cur = FLGun.get(); if (f && cur && cur.b === g.b && cur.l === g.l) go.textContent = 'See the ' + Object.keys(f).length + ' holsters made for it \u2192'; });
  }
  function openPanel(from) {
    if (!FLGun.get()) { location.href = FLGun.finderUrl(null); return; }
    if (!panel) {
      panel = document.createElement('div'); panel.className = 'flmy-panel'; panel.hidden = true;
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Your pistol');
      panel.innerHTML = '<button type="button" class="flmy-panel__x" data-flmy-x aria-label="Close">\u00d7</button>' +
        '<p class="flmy-panel__k">Your pistol</p><p class="flmy-panel__gun" data-flmy-gun></p>' +
        '<a class="flmy-panel__go" data-flmy-go href="#"></a>' +
        '<p class="flmy-panel__k flmy-panel__sep">Change pistol</p>' +
        '<div class="flgs" data-flgs data-mode="set" data-via="header">' + SEARCH_SVG + '<input type="search" autocomplete="off" placeholder="e.g. Glock 19" aria-label="Search your pistol"><ul role="listbox" hidden></ul></div>' +
        '<button type="button" class="flmy-panel__clear" data-flmy-clear>Clear my pistol</button>';
      document.body.appendChild(panel);
      panel.querySelector('[data-flmy-x]').onclick = closePanel;
      panel.querySelector('[data-flmy-clear]').onclick = function () { closePanel(); FLGun.clear(); };
      if (window.FLGunSearch) FLGunSearch.mount(panel.querySelector('[data-flgs]'));
      document.addEventListener('click', function (e) {
        if (panel.hidden || panel.contains(e.target) || !document.contains(e.target) || e.target.closest('[data-flmy], [data-flmy-open]')) return;
        closePanel();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
    }
    fillPanel();
    var r = from.getBoundingClientRect(), w = innerWidth < 960 ? innerWidth - 24 : Math.min(340, innerWidth - 24);
    panel.style.width = w + 'px';
    panel.style.top = Math.round(Math.max(r.bottom, 0) + 8) + 'px';
    panel.style.left = Math.round(Math.min(Math.max(12, r.right - w), innerWidth - w - 12)) + 'px';
    panel.hidden = false;
    if (from.hasAttribute('data-flmy')) from.setAttribute('aria-expanded', 'true');
  }
  function pills() {
    var g = FLGun.get();
    document.querySelectorAll('[data-flmy]').forEach(function (b) {
      var n = b.querySelector('[data-flmy-name]'); if (n) n.textContent = g ? FLGun.short(g) : '';
      b.title = g ? 'Your pistol: ' + FLGun.short(g) : '';
      if (b.__flmy) return; b.__flmy = 1;
      b.addEventListener('click', function (e) { e.preventDefault(); if (panel && !panel.hidden) closePanel(); else openPanel(b); });
    });
  }
  window.FLMy = { open: openPanel, close: closePanel };
  // once per session, put the remembered pistol / finder use on the cart (a returning shopper's new cart has neither)
  function syncCart() {
    try {
      var g = FLGun.get(), f = localStorage.getItem('fl.finder'), key = (g ? FLGun.label(g) : '') + '|' + (f || '');
      if (!FLGun.attrs || (!g && !f) || sessionStorage.getItem('fl.attrs') === key) return;
      sessionStorage.setItem('fl.attrs', key);
      var a = {}; if (g) a._fl_gun = FLGun.label(g); if (f) a._fl_finder = f;
      FLGun.attrs(a);
      if (g && typeof window.clarity === 'function') window.clarity('set', 'fl_gun', FLGun.label(g));
    } catch (e) {}
  }
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(decorate, 120); }
  function start() {
    modelPage(); decorate(); personalize(); pills(); syncCart();
    document.addEventListener('fl:gun', function () { schedule(); personalize(); pills(); if (panel && !panel.hidden) fillPanel(); });
    try { new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) { for (var j = 0; j < ms[i].addedNodes.length; j++) { var n = ms[i].addedNodes[j]; if (n.nodeType === 1 && (n.matches('[data-fl-handle]') || n.querySelector('[data-fl-handle]'))) { schedule(); return; } } } }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
